import { useModals } from "web/hooks/modals"
import AddTileWizard from "./AddTileWizard"

export default function useAddTileWizard({
  isTemplate,
  overviewFetchParams,
  subjectType,
  subjectId,
}) {
  const { showModal } = useModals()
  return async function () {
    return await showModal({
      fullScreen: false,
      heightPixels: 800,
      message: "Adding tile. Please wait.",
      title: "Add New Tile",
      widthPixels: 800,
      component: ({ close }) => (
        <AddTileWizard
          closeWizardHandler={close}
          isTemplate={isTemplate}
          overviewFetchParams={overviewFetchParams}
          subjectType={subjectType}
          subjectId={subjectId}
        />
      ),
    })
  }
}
